const INPUT_DEBOUNCE = 1000 // ms
const DEFAULT_LIST_LENGTH = 10
const FIELD = {
	MOBILE: 'mobile',
	EMAIL: 'email',
	FULL_NAME: 'fullName',
	LAST_NAME: 'lastName',
}

export { DEFAULT_LIST_LENGTH, INPUT_DEBOUNCE, FIELD }
